import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "@finitless/shared/lib";
import { isEndpointEnabled } from "@finitless/shared/config";

export const useToggleUserStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ userId, enabled }) => {
      const response = await apiClient.post(`/users/${userId}`, {
        enabled: enabled,
      });
      return response;
    },
    onSuccess: (data, variables) => {
      const { userId, enabled } = variables;
      // Update all users queries in the cache optimistically
      queryClient.setQueriesData({ queryKey: ["users"] }, (oldData) => {
        if (!oldData || !oldData.users || !Array.isArray(oldData.users)) {
          return oldData;
        }

        return {
          ...oldData,
          users: oldData.users.map((user) =>
            user.id === userId ? { ...user, enabled } : user,
          ),
        };
      });

      // Update specific user query in the cache
      queryClient.setQueriesData({ queryKey: ["user", userId] }, (oldData) => {
        if (!oldData) return oldData;
        return { ...oldData, enabled };
      });

      // Invalidate and refetch users queries to ensure consistency
      queryClient.invalidateQueries({ queryKey: ["users"] });
      queryClient.invalidateQueries({ queryKey: ["user", userId] });
      queryClient.invalidateQueries({ queryKey: ["users", "stats"] });
      queryClient.invalidateQueries({ queryKey: ["users", "tab"] });
    },
    enabled: isEndpointEnabled("dashboard", "users"),
  });
};

export default useToggleUserStatus;
